<template>
  <div>
    <div
      class="card-filter-section d-flex align-items-center justify-content-between mt-0"
    >
      <p class="task-timesheet m-0">
        Client
      </p>

      <div class="role-buttons d-flex flex-wrap align-items-center">
        <!-- add client button  -->
        <table-button
          v-b-toggle.addclient
          btn-name="add Client"
        />
        <!-- add client button  -->
        <Help
          v-show="$store.state.app.userManualList"
          code="Client"
        />
      </div>

    </div>
    <!--filter start-->
    <div class="card-filter-section">
      <div class="d-flex align-items-center flex-wrap justify-content-between">
        <div class="d-flex align-items-center justify-content-start flex-wrap">
          <p class="filter-title">
            Filters:
          </p>

          <div class="">
            <custom-dropdown
              v-model="is_active"
              :options="isActiveList"
              :search-box="false"
              :hide-close="true"
              label="Active"
              icon="EditIcon"
            />
          </div>
          <div class="">
            <custom-dropdown
              v-model="country"
              :options="countries"
              label="Country"
              icon="EditIcon"
              multiple
            />
          </div>
          <option-drop-down v-model="perPage" />
        </div>
        <div class="d-flex align-items-center">
          <b-input-group
            class="input-group-merge search-project"
            style="min-width: 250px; max-width: 250px; width: 250px"
          >
            <b-form-input
              v-model="debouncedSearch"
              placeholder="Search by Client Name"
            />

            <b-input-group-append is-text>
              <feather-icon
                v-if="debouncedSearch"
                icon="XIcon"
                @click="debouncedSearch = null,search = null"
              />
              <feather-icon icon="SearchIcon" />
            </b-input-group-append>
          </b-input-group>

          <div class="ml-1">
            <button
              class="apply-filter filterRedesign mr-1"
              @click="getClientData()"
            >
              Apply Filter
            </button>
            <button
              class="apply-filter-clear filterRedesign"
              @click="clearFilter()"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--filter end-->
    <div class="table role">
      <!-- Table start from here -->
      <table-loader
        v-if="loading"
        :fields="fields"
      />
      <b-row v-else>
        <b-col cols="12">
          <!-- data table start-->
          <b-table
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="scrollable-element tableDesigns mastertblColor non-project-table"
          >
            <template #cell(is_active)="data">
              <b-form-checkbox
                v-model="data.item.is_active"
                class="custom-control-success"
                name="check-button"
                size="md"
                switch
                @change="changeStatus(data.item, data.item.is_active)"
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </template>

            <template #cell(action)="data">
              <span>
                <feather-icon
                  v-b-tooltip.hover.top="'Edit'"
                  icon="EditIcon"
                  role="button"
                  class="mr-1 text-dark"
                  size="18"
                  @click="edit(data.item)"
                />
                <feather-icon
                  v-b-tooltip.hover.top="'Delete'"
                  icon="Trash2Icon"
                  role="button"
                  class="text-danger"
                  size="18"
                  @click="deleteConfirmation(data.item.id)"
                />
              </span>
            </template>
          </b-table>

          <!-- data table complete -->
          <img
            v-if="totalCount == 0"
            src="@/assets/images/nodatafound/nodata.svg"
            alt="no-data"
            class="no-data-img"
          >
        </b-col>

      </b-row>
      <!-- pagination section -->
      <Pagination
        v-if="totalCount>0 && !loading"
        :current-page="currentPage"
        :per-page="perPage"
        :total-count="totalCount"
        @currentPage="currentPage = $event"
      />
      <!-- pagination section complete here -->

      <!-- from start -->
      <client-table-form @clientList="getClientData" />
      <!-- form complete here -->
    </div>
  </div>
</template>

<script>
import customDropdown from '@/components/dropdown/customDropdown.vue'
import { eventBus } from '@/main'
import debounce from 'lodash/debounce'
import TableButton from '../../@core/components/buttons/TableButton.vue'
import ClientTableForm from '../../@core/components/table-from/ClientTableForm.vue'

export default {
  name: 'ClientTable',
  components: {
    ClientTableForm,
    TableButton,
    customDropdown,
  },
  data() {
    return {
      totalCount: 0,
      currentPage: 1,
      perPage: 10,
      loading: true,
      sortBy: 'name',
      sortDesc: false,
      is_active: 'active',
      search: null,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true,
          thStyle: { width: '400px' },
          tdStyle: { width: '400px' },
        },
        {
          key: 'country.name',
          label: 'country',
          sortable: true,
          thStyle: { width: '400px' },
          tdStyle: { width: '400px', textAlign: 'start' },
        },
        {
          key: 'is_active',
          label: 'Active',
          sortable: false,
          thClass: 'text-right',
          tdClass: 'text-right',
        },
        {
          key: 'action',
          label: 'Action',
          sortable: false,
          thStyle: { width: '100px' },
          tdStyle: { width: '100px' },
          thClass: 'text-right',
          tdClass: 'text-right',
        },
      ],
      items: [],
      countries: [],
      country: [],
    }
  },
  computed: {
    debouncedSearch: {
      get() {
        return this.search
      },
      set: debounce(function (value) {
        this.search = value
        this.getClientData()
      }, 750),
    },
  },

  watch: {
    /**
     * @description on page number change Call getClientData()
     */
    currentPage: {
      handler(value) {
        if (value) {
          this.getClientData()
        }
      },
    },
    perPage() {
      if (this.currentPage == 1) {
        this.getClientData()
      } else {
        this.currentPage = 1
      }
    },
  },
  mounted() {
    this.getClientData()
    this.getCountryData()
    eventBus.$on('clientList', data => {
      if (data) {
        this.currentPage = 1
        this.getClientData()
      }
    })
  },

  methods: {
    /**
     * @description Get Client List
     * @method POST
     * @returns items (variable)(client list)
     */
    async getClientData() {
      this.loading = true
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        sort_field: this.sortBy,
        sort_order: this.sortDesc ? 'desc' : 'asc',
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
        search: this.search,
        country_id: this.country ? this.country : null,
      }

      const response = await this.getHTTPPostResponse(
        'admin/master/client',
        input,
      )
      if (response && response.data) {
        const { data } = response
        this.items = data.clients
        this.totalCount = data.count
      }
      this.loading = false
    },

    /**
     * @description For Edit Client pass data of client to client table form
     * @emits edit-client
     */
    edit(data) {
      eventBus.$emit('edit-client', data)
    },

    /**
     * @description Change client status
     * @param {index}  array index
     * @param {value}  value (true, false)
     * @returns if change then call updatestatus method
     */

    async changeStatus(index) {
      const client = this.items.find(item => item === index)

      if (!client) {
        return
      }

      const label = client.is_active ? 'Active' : 'Deactive'
      const title = `Are you sure ${label} Client?`
      const confirmation = await this.conformationAlert(false, title, label)

      if (confirmation.isConfirmed) {
        this.updateStatus(client)
      } else {
        this.items = []
        this.getClientData()
      }
    },

    /**
     * @description Update Client status
     * @method POST
     * @param {data} data(Client Infomation in Array)
     * @returns Client Status update
     */
    async updateStatus(data) {
      const response = await this.getHTTPPostResponse(
        `admin/master/client/status/${data.id}?active=${
          data.is_active ? 1 : 0
        }`,
        {},
        true,
      )
      if (response && response.status === 200) {
        this.getClientData()
      }
    },

    /**
     * @description confirmation to delete user
     * @param {id} client id
     * @returns if conform to delete call deleteClient function
     */
    async deleteConfirmation(id) {
      const value = await this.conformationAlert(true)
      if (value.isConfirmed === true) {
        this.deleteClient(id)
      }
    },

    /**
     * @description delete client
     * @method DELETE
     * @param {id}  client name
     * @returns delete Client
     */
    async deleteClient(id) {
      const response = await this.getHTTPDeleteResponse(
        `admin/master/client/delete/${id}`,
        {},
        true,
      )
      if (response && response.status === 200) {
        this.getClientData()
        this.search = null
      }
    },

    /**
     * Get Countries data
     * @returns Countries (variable)
     */
    async getCountryData() {
      const input = {
        sort_field: 'name',
        sort_order: 'asc',
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/client/countries-list',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.countries = (data && data.countries) ? data.countries.map(country => ({
          value: country.id,
          label: country.name,
        })) : []
      }
    },

    clearFilter() {
      this.country = []
      this.perPage = 10
      this.search = null
      this.is_active = 'active'
      this.getClientData()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "./../../assets/scss/component-css/masterSettingFilter.scss";
</style>
